var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "115.000000pt",
    height: "102.000000pt",
    viewBox: "0 0 115.000000 102.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,102.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285 745 l-280 -274 22 -23 23 -22 35 34 35 34 0 -247 0 -247 180 0 180 0 0 210 0 210 95 0 95 0 0 -210 0 -210 180 0 180 0 0 247 0 247 35 -34 35 -34 23 22 22 23 -280 274 c-154 151 -284 274 -290 274 -5 0 -136 -123 -290 -274z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHover);
export default __webpack_public_path__ + "static/media/home-hover.70a78e32f352644328247c7837f47aa6.svg";
export { ForwardRef as ReactComponent };